import * as React from 'react';
import { init as onfidoInit, OnfidoCompleteResponse } from 'onfido-sdk-ui';
import '../../../../../styles/OnfidoInput.css';

interface Props {
    sdkToken: string;
    phoneNumber?: string;
    onComplete(documentId: string): void;
}

export class OnfidoInput extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        let onComplete = async (data: OnfidoCompleteResponse) => {
            this.props.onComplete(data.document_front.id);
        };

        let onfidoOut = onfidoInit({
            // the JWT token that you generated earlier on
            token: this.props.sdkToken,
            // id of the element you want to mount the component on
            containerId: 'onfido-mount',

            onComplete: onComplete,
            // You can now trigger your backend to start a new check
            smsNumberCountryCode: 'US',

            userDetails: { smsNumber: `+1${this.props.phoneNumber}` }
        });

        onfidoOut.setOptions({
            steps: [
                {
                    type: 'welcome',
                    options: { title: 'Please Verify Your Identity', descriptions: [] }
                },
                { type: 'document' },
                { type: 'face' },
                {
                    type: 'complete',
                    options: { message: 'Document Upload Complete' }
                }
            ]
        });
    }

    render() {
        return (
            <div>
                <div id="onfido-mount" />
            </div>
        );
    }
}

export default OnfidoInput;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/verification/OnfidoInput.tsx